<dx-popup
  [width]="400"
  [height]="185"
  title="Save As... (Custom Extension)"
  [(visible)]="popupVisible"
>
  <div *dxTemplate="let data of 'content'">
    {{ message }}
    <dx-text-box [(value)]="inputText"></dx-text-box>
  </div>
  <dxi-toolbar-item
    toolbar="bottom"
    widget="dxButton"
    location="after"
    [options]="{
      text: 'Save',
      onClick: saveButtonAction
    }"
  >
  </dxi-toolbar-item>
  <dxi-toolbar-item
    toolbar="bottom"
    widget="dxButton"
    location="after"
    [options]="{
      text: 'Cancel',
      onClick: cancelButtonAction
    }"
  >
  </dxi-toolbar-item>
</dx-popup>
